import { useEffect, useCallback } from 'react';
import { useForm, useLocale } from 'hooks';
import * as Constants from '@/redux/constants';
import get from 'lodash/get';
import EntrySelectPage from './components/select';
import EntryFormPage from './components/form';

function EntryPage() {
  const locale = useLocale();
  const {
    itemInfo,
    optionsItemInfo,
    control,
    errors,
    watch,
    setValue,
    fields,
    registerOptions,
    isFetching,
    onSubmit,
  } = useForm({
    model: 'PublicGiving',
    formType: 'public',
    payload: {
      locale,
    },
  });

  const watchRequireReceipt = false; // watch('requireReceipt');

  useEffect(() => {
    switch (itemInfo.type) {
      case Constants.CREATE_PUBLIC_GIVING.SUCCESS: {
        const paymentUrl = get(itemInfo, 'data.onlinePayment.paymentUrl');
        if (paymentUrl) {
          location.href = paymentUrl;
        }
      }
        break;
    }
  }, [itemInfo]);

  useEffect(() => {
    document.title = 'Do Not Require a Receipt – St Andrews Church Kowloon';
  }, []);

  const onSelectRequireReceipt = useCallback((value) => {
    setValue('requireReceipt', value);
  }, [setValue]);

  if (watchRequireReceipt === null || watchRequireReceipt === undefined) {
    return (
      <EntrySelectPage onSelect={onSelectRequireReceipt} />
    );
  } else {
    return (
      <EntryFormPage
        itemInfo={itemInfo}
        optionsItemInfo={optionsItemInfo}
        control={control}
        errors={errors}
        fields={fields}
        registerOptions={registerOptions}
        isFetching={isFetching}
        onSubmit={onSubmit}
        watch={watch}
        setValue={setValue}
      />
    );
  }
}

export default EntryPage;
